<a
  [finLink]="link"
  [external]="external"
  [finElemTracker]="'level-1: ' + link"
  [finElemContext]="TRACKING_CONTEXT"
  [finElemType]="ElementTypes.LINK"
  [attr.target]="openInNewTab ? '_blank' : ''"
  [attr.aria-current]="active ? 'page' : null"
  [attr.aria-disabled]="active ? 'true' : null"
  (click)="onLinkClick($event)"
  [class]="
    'sidebar-navigation-item ps-large-x mr-xxsmall-y no-decoration flex flex--middle ' +
    styleClasses +
    (active ? ' active' : '')
  "
>
  {{ title }}
  <span *ngIf="active" class="is-vishidden">{{ 'navigation.currentPage' | finLocalization }}</span
  ><fcom-icon *ngIf="external" name="external-tab" class="icon-small ms-xxsmall-l"></fcom-icon>
  <fcom-icon *ngIf="loginRequired" name="lock-open" class="icon-small ms-xxsmall-l"></fcom-icon>
</a>
